import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../services/Api';
import { authHeader } from '../../services/auth-header';
import Swal from 'sweetalert2';
import AraiMEdit from './AraiManufacturing/Edit';
import PIEdit from './PumpSpareInternational/Edit';

function PoEnquiryEdit() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [purchaseEnquiryType, setPurchaseEnquiryType] = useState('');
  const [purchaseEnquiryCategory, setPurchaseEnquiryCategory] = useState('');
  const [purchaseData, setPurchaseData] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}purchaseEnquiry/findById/${id}`, {
          headers: authHeader(),
        });
        setPurchaseData(response.data);
        setPurchaseEnquiryType(response.data.purchaseenquirytype);
        setPurchaseEnquiryCategory(response.data.purchaseenquirycategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (purchaseEnquiryType === 'Pump Spare' && purchaseEnquiryCategory === 'International') {
      return <PIEdit />;
    } else if (purchaseEnquiryType === 'Manufacturing') {
      return <AraiMEdit />;
    }
    return null;
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.get(`${BASE_URL}purchaseEnquiry/purchaseEnquiryCancelStatus/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/poenquiryindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  async function cancelHandler() {
    try {
      await axios.get(`${BASE_URL}purchaseEnquiry/purchaseEnquiryCancelStatus/${id}`, {
        headers: authHeader(),
      });
      navigate(`/poenquiryindex/${pointindex}`);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>UPDATE PURCHASE ENQUIRY</h6>
          <div className="view-buttons">
            <Link to={`/poenquiryindex/${pointindex}`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={purchaseEnquiryType}>
                  <option value="">--Please choose an option--</option>
                  {/* Removed Tubing */}
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Category:</Form.Label>
                <Form.Select disabled value={purchaseEnquiryCategory}>
                  <option value="">--Please choose an option--</option>
                  {/* Tubing values removed, but Domestic/International kept in case used by other types */}
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PoEnquiryEdit;
